import React, { useEffect, useState } from 'react'

export default function SuggestedAmountsModal({proceed, close, suggestedAmounts}) {
    const [amount, setAmount] = useState(0)
    const [amounts, setAmounts] = useState(suggestedAmounts && suggestedAmounts ? suggestedAmounts : [])
    const [editID, setEditID] = useState(null)

    const deletePlan = (id) => {
        let newList = amounts.filter((item) => item.id !== id)
        setAmounts(newList)
    }

    const updatePlan = () => {
        if (amount < 3) {
            Alert.show('error', 'Amount must be more than $3')
            return
        }

        if (editID) {
            let newList = amounts.map((item) => {
                if (parseInt(editID) === parseInt(item.id)) {
                    return { ...item, value: parseInt(amount) }; // update value
                }
                return item; // leave unchanged
            });
            setAmount(0)
            setEditID(null)
            setAmounts(newList)
        } else {
            let amountObj = {id: amounts.length > 0 ? amounts[amounts.length - 1].id + 1 : 1, value: parseInt(amount)}
            let newList = [...amounts, amountObj];
            setAmounts(newList)
            setAmount(0)
        }
    }

    const validateFunction = () => {
        if (!Array.isArray(amounts) || amounts.length % 3 !== 0) {
            Alert.show('notice', 'Please add donation amounts in groups of 3 for a balanced layout.');
            return false;
        }

        proceed(amounts)
    };

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                <h4>Suggested Amounts (USD)</h4>

                {amounts && amounts.map((item) => (
                    <div key={item.id} className='d-flex justify-content-between align-items-center mb-2'>
                        <p>${(item.value)}</p>
                        <button
                            type='button' 
                            className='btn btn-icon' 
                            style={{border: 'none'}}
                        >
                            <i 
                                className='fa fa-pencil text-primary mr-2'
                                onClick={() => {setEditID(item.id); setAmount(item.value)}}
                            >
                            </i>
                            <i 
                                className='fa fa-trash text-danger'
                                onClick={() => deletePlan(item.id)}
                            >
                            </i>
                        </button>
                    </div>
                ))}

                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <label htmlFor='name'>Amount (USD)</label>
                            <div className="input-group">
                                <input type='number' step="1" className='form-control' name='name' id='name' placeholder='Amount' 
                                    value={amount} onChange={(event) => setAmount(event.target.value)}
                                />
                                <div className="input-group-append">
                                    <button 
                                        className="btn btn-light btn-border" 
                                        type="button" 
                                        onClick={updatePlan}
                                        disabled={!amount}
                                    >
                                        {editID ? 'Update' : 'Add'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pt-3">
                    <button onClick={() => validateFunction()} type="button" className="btn btn-primary mr-2">
                        Proceed
                    </button>

                    <button onClick={() => close()} type="button" className="btn btn-secondary mr-2">
                        Close
                    </button>
                </div>
                <small>We highly recommend setting this value. If left blank, a default will be provided automatically.</small>
            </div>
        </div>
    </div>
  )
}
